<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.sendEmailManagement") }}</h4>
    </div>
    <div class="wrap_con type_bt_wrap">
      <div class="mb-5 pb-3">
        <div class="float-end">
          <div class="list_top_search d-flex">
            <input
              type="text"
              id="searchWord"
              v-model="form.searchWord"
              name="searchWord"
              value=""
              class="m-1 form-control"
            />
            <button @click="searchBtn" class="btn btn-primary btn-lg">
              {{ $t("support.notice.search") }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <div style="text-align: right">
          <router-link
            :to="{ name: 'emailSendForm' }"
            class="btn btn-primary btn-md mb-2"
            >{{ $t("common.send") }}</router-link
          >
        </div>
        <div>
          <table class="list_tbl">
            <thead>
              <tr>
                <th class="mobile_row">
                  {{ $t("common.title")
                  }}<span class="mobile_vt"
                    >/ {{ $t("support.notice.classify") }} /
                    {{ $t("support.notice.writer") }} / {{ $t("support.notice.date") }} /
                    {{ $t("support.notice.file") }}</span
                  >
                </th>
                <th class="mobile_h">{{ $t("common.writer") }}</th>
                <th class="mobile_h">{{ $t("common.date") }}</th>
                <th class="mobile_h">{{ $t("management.sendYN") }}</th>
                <th class="mobile_h">{{ $t("management.recipientCnt") }}</th>
              </tr>
            </thead>
            <tbody v-if="emailList.length != 0">
              <tr
                v-for="(email, index) in emailList"
                :key="index"
                @click="goSendForm(email.mailId)"
                class="active_mouseover"
              >
                <td class="text-left">
                  {{ email.mailTitle }}
                </td>
                <td>{{ email.userName }}</td>
                <td>{{ email.sendDatetime }}</td>
                <td>{{ email.sendYn }}</td>
                <td>{{ email.recipientCnt }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5">{{ $t("common.noData") }}</td>
              </tr>
            </tbody>
          </table>
          <div v-if="emailList.length != 0" class="paging_nav">
            <div class="paging_nav">
              <a
                href="javascript:void(0)"
                v-if="pagingVO.startPage <= pagingVO.blockSize"
                class="page_select prev_page disabled"
                >이전페이지 이동</a
              >
              <a
                v-else
                class="page_select prev_page"
                @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
                v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
                >이전페이지 이동</a
              >
              <span
                v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
                :key="index"
              >
                <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
                  pagingVO.startPage + index
                }}</strong>
                <a
                  href="javascript:void(0)"
                  v-else
                  @click="searchPage(pagingVO.startPage + index)"
                  >{{ pagingVO.startPage + index }}</a
                >
              </span>
              <a
                v-if="pagingVO.endPage >= pagingVO.totalPage"
                href="javascript:void(0)"
                class="page_select next_page disabled"
                >다음페이지 이동</a
              >
              <a
                v-else
                href="javascript:void(0)"
                @click="searchPage(pagingVO.endPage + 1)"
                v-bind:data-page="pagingVO.endPage + 1"
                class="page_select next_page"
                >다음페이지 이동</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getEmailList } from "@/api/mail";

export default {
  data() {
    return {
      emailList: [],
      form: {
        page: 1,
        searchWord: "",
      },
      pagingVO: "",
    };
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getEmailList(this.form);
        this.pagingVO = data.pagingVO;
        this.emailList = data.pagingVO.dataList;
      } catch (error) {
        console.log(error);
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.$store.commit("setPage", page);
      this.fetchData();
    },
    searchBtn() {
      this.form.page = 1;
      this.$store.commit("setSearchWord", this.form.searchWord);
      this.fetchData();
    },
    goSendForm(mailId) {
      this.$router.push({ name: "emailSendForm", params: { mailId: mailId } });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style></style>
